import { partition, includes, keys } from 'ramda';
import InternalLinkMod from './InternalLinkMod';
import Provider from './InternalLinkModProvider';
import { VendingMachineLinks } from '../VmLocationContainer';

type OwnProps = {
  internalLinks: { vendingMachineLinks: VendingMachineLinks };
  urlRoot?: string;
};

export default function InternalLinkModContainer({
  internalLinks,
  urlRoot = ''
}: OwnProps) {
  const internalLinksKeys = keys(internalLinks);
  const partitionedKeys = partition(
    includes('popularMakesModels'),
    internalLinksKeys
  );
  const [topKey, linkKeys] = partitionedKeys;

  return linkKeys.length > 0 ? (
    <Provider internalLinks={internalLinks}>
      {topKey.length > 0 && (
        <InternalLinkMod linkKey={topKey[0]} minLinks={9} />
      )}
      {linkKeys.map(internalLinkKey => (
        <InternalLinkMod
          linkKey={internalLinkKey}
          minLinks={9}
          key={internalLinkKey}
          urlRoot={urlRoot}
        />
      ))}
    </Provider>
  ) : null;
}
